<template>
    <div class="row">
        <b-modal id="create-group-key" title="Banka Dosyası Kimliği Oluştur" no-close-on-esc no-close-on-backdrop>
            <group-key-create v-model="groupKey"></group-key-create>
            <template #modal-footer><v-executer :loading="groupKeyCreating" :action="createGroupKey" text="Oluştur"></v-executer></template>
        </b-modal>
        <div class="col-12 mb-1">
            <label class="form-label">Personel</label>
            <v-select-list v-model="employee" label="Combine" placeholder="Personel" :options="employees"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İzin Türü</label>
            <v-select-list v-model="type" label="Name" placeholder="İzin Türü" :options="types"/>
        </div>
        <div class="col-12 mb-1" v-if="$safe(type,'Sterling')">
            <label class="form-label">Banka Dosyası Kimliği</label>
                <div class="d-flex">
                
                <select :disabled="groupKeyGetting" class="form-control" v-model="value.GroupKey">
                    <option :value="null">Ödeme Yok</option>
                    <option v-for="(gk,i) in groupKeys" :key="i" :value="gk.GroupKey">{{ gk.GroupKey }} - [{{ gk.DateStr }}] | ({{ gk.BankAccount.Bank.BankName }} - {{ gk.BankAccount.AccountNumber }})[{{gk.BankAccount.Name}}]</option>
                </select>
                <v-executer class="ml-50" :loading="groupKeyGetting" :action="getGroupKeys" text="Yenile" />
                <button v-on:click="showCreateGroupKey" class="btn btn-outline-secondary ml-50">Ekle</button>
            </div>
        </div>
        <div class="col-12 mb-1" v-if="$safe(type,'IsDocumentRequired')">
            <label class="form-label">Belge</label>
            <v-file-uploader v-model="value" :accept="['pdf','png','jpeg','jpeg']" value-parameter="Document"></v-file-uploader>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Talep Tarihi</label>
            <v-date-picker type="datetime" v-model="value.RequestDate" placeholder="Talep Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-date-picker type="datetime" v-model="value.StartDateTime" placeholder="Başlangıç Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bitiş Tarihi</label>
            <v-date-picker type="datetime" v-model="value.EndDateTime" placeholder="Bitiş Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İş Başı Tarihi</label>
            <v-date-picker type="datetime" v-model="value.JobStartDateTime" :disabled="!value.EndDateTime" :disabled-date="disabledDate" placeholder="Bitiş Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <textarea v-model="value.Description" placeholder="Açıklama" class="form-control resize-none"></textarea>
        </div>
        <div class="col-12">
            <label class="form-label">Durum</label>
            <select class="form-control" v-model="value.Approved">
                <option v-for="(item,index) in statutes" :key="index" :value="item.value">{{item.text}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import moment from 'moment'
import GroupKeyCreate from './GroupKeyCreateExcuse.vue'

export default {
    components:{
        VFileUploader,
        GroupKeyCreate
    },
    props:{
        value:Object,
        types:Array,
    },
    data(){
        return{
            groupKeys:[],
            groupKeyGetting:false,
            groupKey:{
                Date:null,
                CompanyBankAccountId:null
            },
            groupKeyCreating:false,
            employees:[],
            statutes:[
                {text:"Beklemede",value:null},
                {text:"Onaylandı",value:true},
                {text:"Reddedildi",value:false},
            ]
        }
    },
    mounted(){
        this.getEmployees()
    },
    watch:{
        "value.EndDateTime"(val){
            if(val){
                if(moment(val,'YYYY-MM-DD HH:mm').isValid()){
                    this.value.JobStartDateTime = moment(val,'YYYY-MM-DD HH:mm').add(1,'days').format('YYYY-MM-DD HH:mm')
                }else this.value.JobStartDateTime = null
            }else this.value.JobStartDateTime = null
        }
    },
    methods:{
        getGroupKeys(){
            this.groupKeyGetting = true
            // 5 = Yıllık İzin Avansı: dosya oluştururken kullanılan tür ile aynı olmalı ki
            // listede yalnızca YIA dosyaları çıksın (İcra dosyaları seçilemesin).
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyList(true, 5).then(res => {
                this.groupKeys = res.data.Data
                this.groupKeyGetting = false
            }).catch(err => {
                this.groupKeyGetting = true
            })
        },
        showCreateGroupKey(){
            // this.groupKey.Date = this.assignData.Date
            this.groupKey.CompanyBankAccountId = null
            this.$showModal('create-group-key')
        },
        createGroupKey(){
            this.groupKeyCreating = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyCreate(this.groupKey.Date,this.groupKey.CompanyBankAccountId,5).then(res=>{
                this.groupKeyCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-group-key')
                    this.getGroupKeys()
                }
            }).catch(err => {
                this.groupKeyCreating = false
                this.$result(null,err)
            })
        },
        getEmployees(){
            EmployeeOperationsApi.Employee.List().then(res=>{
                this.employees = res.data.Data?.map(f => ({...f,Combine:[f.FullName,f.IdentityNumber].join(' - ')}))
            })
        },
        disabledDate(date){
            if(this.value.EndDateTime){
                let startDate = moment(this.value.EndDateTime,'YYYY-MM-DD HH:mm')
                let currentDate = moment(date)
                if(currentDate.isSameOrBefore(startDate)) return true
                else return false
            }else return false
        }
    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(b=>b.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        type:{
            get:function(){
                this.getGroupKeys()
                return this.types.find(b=>b.Id==this.value.ExcuseTypeId)
            },
            set:function(value){
                this.value.ExcuseTypeId = value?.Id || null
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>